export const tasks = {
  tabs: {
    pending: 'Pending',
    attempted: 'Attempted',
    completed: 'Completed'
  },
  options: {
    all: 'All',
    unassigned: 'Unassigned'
  },
  columns: {
    patientName: 'Patient Name',
    type: 'Type',
    subType: 'Sub Type',
    priority: 'Priority',
    medication: 'Medication',
    billedAmount: 'Billed Amount',
    bonusAmount: 'Bonus Amount',
    modeOfResolution: 'Mode Of Resolution',
    status: 'Status',
    createdAt: 'Created At'
  },
  filters: {
    priorityLabel: 'Priority',
    priorityPlaceholder: 'select a priority',
    addedOnOrBeforeLabel: 'Added (on or before)',
    encountersLabel: 'No of Encounters',
    encountersPlaceholder: 'select encounter count',
    organizationLabel: 'Organization',
    organizationsLabel: 'Organizations',
    organizationPlaceholder: 'select an organization',
    locationLabel: 'Location',
    storesLabel: 'Stores',
    storePlaceholder: 'select a store',
    assigneeLabel: 'Assignee',
    pharmacistsLabel: 'Pharmacists',
    pharmacistPlaceholder: 'select an Pharmacist',
    getTasksButton: 'Get Tasks',
    resetButton: 'Reset'
  },
  reportDashboard: {
    title: 'My Tasks',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date'
  }
} as const;
